import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const ErrorDialog = ({ open, handleClose, title, message, details, primaryActionText, onPrimaryAction }) => {
  const showPrimaryAction = Boolean(primaryActionText && onPrimaryAction);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          p: { xs: 2, sm: 4 },
          minWidth: { xs: 'auto', sm: '500px' },
          maxWidth: '711px',
          borderRadius: 4,
          width: { xs: 'calc(100% - 32px)', sm: 'auto' },
          m: { xs: 2, sm: 4 },
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
        {details && (
          <DialogContentText style={{ marginTop: '8px', color: 'grey' }}>
            Details: {details}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {showPrimaryAction && (
          <Button onClick={onPrimaryAction} color="primary">
            {primaryActionText}
          </Button>
        )}
        <Button onClick={handleClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ErrorDialog.defaultProps = {
  title: "Error",
  message: "An error occurred.",
  details: null,
  primaryActionText: null,
  onPrimaryAction: null
};

export default ErrorDialog;
